import { BaseAction } from "../../../core/actions/BaseAction";
import { _eventBus } from "../../../core/events/EventBus";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { openLegalDoc } from "../../../Orchestrator/Recoils/LegalDocModalAtom";


export class FooterMenuSelectAction extends BaseAction<void, { path: string, isAuthenticated?: boolean, isRoute?: boolean }> {

    override async run(): Promise<void | null> {
        try {
            const { path, isAuthenticated, isRoute } = this.params!;
            updateRecoilState("selectedMenuAtom", path)

            if (isRoute) {
                switch (path) {
                    // Legal documents open in the in-app popup so callers
                    // (e.g. checkout) never lose their place.
                    case "terms":
                        openLegalDoc("terms-of-use");
                        break;
                    case "privacyPolicy":
                        openLegalDoc("privacy-policy");
                        break;

                    default:
                        _eventBus.emit({
                            eventName: "ROUTE_CHANGE",
                            data: "/",
                        })
                        break;
                }
            }

        } catch (error) {
            console.error("Error in FooterMenuSelectAction:", error);
        }
    }
}

// Create a singleton instance
export const footerMenuSelectAction = new FooterMenuSelectAction(); 